module.exports = __webpack_public_path__ + "static/media/rumi-logo-pwa@2x.e068286d.jpg";